/*
 *
 * Created on Thu 12 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

const CustomImage = ({
  src = "",
  alt,
  title,
  width = "fit-content",
  height = "100%",
  borderRadius = "0px",
  layout = "intrinsic",
  clickHandler = () => {},
  objectFit = "contain",
  iconClass,
  className,
  style = {},
  divStyle = {},
  ...rest
}) => {
  return src && typeof src === "string" && src.endsWith(".svg") ? (
    <div className={className} style={{ ...divStyle }}>
      <img
        data-loading="lazy"
        src={src}
        alt={alt}
        title={title}
        width={width}
        height={height}
        className={iconClass}
        onClick={clickHandler}
        style={{
          ...style,
        }}
      />
    </div>
  ) : (
    <div className={className} style={{ ...divStyle }}>
      <img
        alt={alt}
        title={title}
        src={src}
        onClick={clickHandler}
        width={width}
        layout={layout}
        height={height}
        className={iconClass}
        style={{
          ...style,
          borderRadius,
        }}
        {...rest}
      />
    </div>
  );
};

export default CustomImage;
